<div class="flex flex-1 flex-col">
  <label for="days" class="text-left text-paragraph-xs-med text-greyscale-700">
    {{ "calculator.label." + placeholder | transloco }} *</label
  >
  <p-autocomplete
    [suggestions]="filteredAirports"
    (completeMethod)="filterAirports($event)"
    [placeholder]="'calculator.placeholder.' + placeholder | transloco"
    forceSelection="true"
    optionLabel="label"
    optionValue="Code"
    data-testid="select-airport-p"
    [(ngModel)]="selectedAirport"
    (onSelect)="handleSelect($event)"
    [fluid]="true"
    (onBlur)="formGroup.get('airportCode')?.markAsTouched()"
    (ngModelChange)="formGroup.get('airportCode')?.markAsDirty()"
  />
  <app-error [control]="this.formGroup.get('airportCode')!" />
</div>
@if (this.isTransit) {
  <div class="flex shrink-0 items-center">
    <button (click)="onDelete()">
      <i
        class="pi pi-times ml-2 !text-gray-500 hover:scale-105 hover:cursor-pointer hover:!text-red-700"
      ></i>
    </button>
  </div>
}
